import { getEffectivePlan } from '@vacationtracker/shared/functions/plan-boost'
import { SubscriptionPlan } from '@vacationtracker/shared/types/company'
import { useAppSelector } from './hooks'
import { selectAuthCompanySlice } from './auth-company-slice'

export const useEffectivePlan = (): SubscriptionPlan | undefined => {
  const { authCompany } = useAppSelector(selectAuthCompanySlice)
  return getEffectivePlan(authCompany)
}
